export default __webpack_public_path__ + "static/media/i-documento-sura.2a0b83cd.svg";